import { render, staticRenderFns } from "./alocacao-por-bp.vue?vue&type=template&id=4301165c&scoped=true&"
import script from "./alocacao-por-bp.vue?vue&type=script&lang=js&"
export * from "./alocacao-por-bp.vue?vue&type=script&lang=js&"
import style0 from "./alocacao-por-bp.vue?vue&type=style&index=0&id=4301165c&lang=scss&scoped=true&"
import style1 from "./alocacao-por-bp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4301165c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VSpacer})
